$(function() {
	$('#searchToggle').click(function() {
		if (!$(this).hasClass('active')) {
			$("#searchBar").addClass('active');
			$("#searchBar").find('input').focus();
			$(this).addClass('active');
			$(this).parent().addClass('active');
			// $("#searchResults").addClass('active');
		} else {
			$("#searchResults").removeClass('active');
			$("#searchBar").removeClass('active');
			$("#searchBar").find('input').focusout();
			$(this).removeClass('active');
			$(this).parent().removeClass('active');
		}
	});

	$("#searchBar").find('input').keydown(function(e){
		if ((!$(this).val().length == 0) && (e.keyCode != 27)) {
			$("#searchResults").addClass('active');
			$('.js-blur-btn').addClass('active');
		} else if (e.keyCode == 27) {
			$(this).val('').blur().focusout();
			$("#searchResults").removeClass('active');
			$('#searchToggle').removeClass('active');
			$('#searchToggle').parent().removeClass('active');
			$("#searchBar").removeClass('active');
		} else {
			$("#searchResults").removeClass('active');
			$('.js-blur-btn').removeClass('active');
		}
	});

	$('.js-blur-btn').click(function(){
		$("#searchBar").find('input').val('').blur();
		$("#searchResults").removeClass('active');
		$(this).removeClass('active');
	});
	$('.open-menu').click(function() {
		if (($(this).hasClass('collapsed'))&&((!$('#searchToggle').hasClass('.active')))) {
			$("#searchBar").removeClass('active');
			$('#searchToggle').removeClass('active');
			$('#searchToggle').parent().removeClass('active');
		};
	});

	$("#searchBar").find('input').focus(function(){
		// $("#searchResults").addClass('active');
	});

	$(".navbar-close").click(function(){
		$("#searchBar").find('input').val('');
		// $("#searchBar").find('input').focusout();
		$("#searchResults").removeClass('active');
	});

	$("#searchBar input").keyup(function(){
		$("#searchResults ul li").fadeOut(500, function(){
		$("#searchResults ul").empty()});
	})
})
